module.exports = __webpack_public_path__ + "img/defaultAvatar.0fd601a.png";